import { render, staticRenderFns } from "./ContactHistorical.vue?vue&type=template&id=265261c9&scoped=true"
import script from "./ContactHistorical.vue?vue&type=script&lang=js"
export * from "./ContactHistorical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265261c9",
  null
  
)

export default component.exports